import {ContractorCategoryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'DELETE_CONTRACTOR_CATEGORY';

export async function deleteContractorCategory(userData: any, contractorCategoryId: number | string) {
    try {
        const result = await ContractorCategoryDao.deleteContractorCategory(userData, contractorCategoryId);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression de la catégorie sous/co-traitant',
            error: error
        });
    }
}
